import { render } from "./PurchaseAttachmentsFilesTable.vue?vue&type=template&id=96466e40&scoped=true&ts=true&lang=pug"
import script from "./PurchaseAttachmentsFilesTable.vue?vue&type=script&lang=ts"
export * from "./PurchaseAttachmentsFilesTable.vue?vue&type=script&lang=ts"

import "./PurchaseAttachmentsFilesTable.vue?vue&type=style&index=0&id=96466e40&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96466e40"]])

export default __exports__